document.addEventListener('DOMContentLoaded', (event) => {
    let accordionArr = Array.from( document.querySelectorAll('.collapsible-content .grid__item .accordion') );
    const showMoreFAQ = document.querySelector('.toggle-accordions');
    showMoreFAQ.addEventListener('click', function() {
        let btnState = this.dataset.state;
        console.log(btnState)
        accordionArr.map((accordion, idx) => {
            if(accordion.classList.contains('hidden-accordion') && btnState === 'hidden'){
                
                accordion.classList.remove('hidden-accordion')
            }
            if(idx > 4 && btnState === 'show'){
                accordion.classList.add('hidden-accordion')
            }
        });
        if(btnState === 'hidden'){
            this.dataset.state = 'show'
            this.innerText = 'Show Less FAQs'
        }else{
            this.dataset.state = 'hidden' 
            this.innerText = 'Show More FAQs'
        }
    })
    
})
